import { z } from 'zod';

export const structuredOutputSchema = z.object({
  message: z.string(),
  code: z.string(),
  title: z.string().optional(),
});
